import useZoneMultiSelect from './UseZoneMultiSelect';
import MultiSelect from '../MultiSelect';

const ZoneMultiSelect = ({ label, name, value, error, message, onChange }) => {
  const { options } = useZoneMultiSelect();

  return (
    <MultiSelect
      label={label}
      name={name}
      value={value}
      options={options}
      error={error}
      message={message}
      isLoading={false}
      onChange={onChange}
    />
  );
}

export default ZoneMultiSelect;